import React, { useEffect, useState } from "react";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import styled from "styled-components";
import { useNavigate, useLocation } from "react-router-dom";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { useUser } from "../../../contexts/user.context";
import { withStyles } from "@material-ui/core/styles";

let gNavigation = [
  {
    label: "Home",
    to: `/ctpo/study-plans/`,
  },
  {
    label: "Study Plans",
    to: `/ctpo/study-plans/`,
  },
  {
    label: "Study Actuals",
    to: `/ctpo/study-actuals/`,
  },
  // { label: "Admin Data", to: `/ctpo/admin-data/` },
];

const StyledTab = withStyles((theme) => ({
  root: {
    color: "var(--White)",
    opacity: 1,
    "&:hover": {
      opacity: 0.8,
    },
  },
}))((props) => (
  <Tab
    disableRipple
    {...props}
  />
));

const Navigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [current, setCurrent] = useState(() => defaultSelected(location));
  const isAuthenticated = useIsAuthenticated();
  const { accounts } = useMsal();
  const { urlStudyId, updateNavigation } = useUser();
  const [navigation, setNavigation] = useState([]);

  useEffect(() => {
    if (!urlStudyId) {
      if (!"/ctpo/study-plans/".includes(location.pathname)) {
        gNavigation = [
          {
            label: "Home",
            to: `/ctpo/study-plans/`,
          },
        ];
        setNavigation(gNavigation);
        setCurrent(0);
      } else {
        gNavigation = [];
        setNavigation(gNavigation);
        setCurrent(false);
      }
    } else {
      gNavigation = [
        {
          label: "Home",
          to: `/ctpo/study-plans/`,
        },
        {
          label: "Study Plans",
          to: urlStudyId
            ? `/ctpo/study-plans/${urlStudyId}`
            : `/ctpo/study-plans/`,
        },
        {
          label: "Study Actuals",
          to: urlStudyId
            ? `/ctpo/study-actuals/${urlStudyId}`
            : `/ctpo/study-actuals/`,
        },
      ];
      setNavigation(gNavigation);
      if (location.pathname.includes("study-plans")) {
        setCurrent(1);
      }
      if (location.pathname.includes("study-actuals")) {
        setCurrent(2);
      }
    }
    // eslint-disable-next-line
  }, [updateNavigation, urlStudyId]);

  // Return null if not authenticated or no accounts
  if (!isAuthenticated || accounts.length === 0) return null;

  const handleChange = (ev, index) => {
    const location = navigation[index].to;
    setCurrent(index);
    navigate(location);
  };

  return (
    <Container>
      <Tabs
        value={current !== false ? current : 0}
        onChange={handleChange}
        TabIndicatorProps={{
          style: {
            backgroundColor: "var(--White)",
          },
        }}
      >
        {navigation.map((nav) => (
          <StyledTab
            key={nav.to}
            label={nav.label}
          />
        ))}
      </Tabs>
    </Container>
  );
};

export default Navigation;

const Container = styled.div`
  margin: 0 1em;
`;

const defaultSelected = (location) => {
  const { pathname } = location;
  pathname.lastIndexOf("/");
  return gNavigation.findIndex((loc) => pathname.includes(loc.to));
};